import { PlayerMediaSource } from "./PlayerMediaSource";
import { gatherVideoClientDataSource } from "./Globals";
export var ConsumerState;
(function (ConsumerState) {
    ConsumerState["WaitingForSFUAddress"] = "Waiting for SFU address";
    ConsumerState["ConnectingToSFU"] = "Connecting to SFU";
    ConsumerState["Consuming"] = "Consuming from SFU";
    ConsumerState["NotAllowed"] = "Not allowed by the other user";
    ConsumerState["ProducerDisconnected"] = "Producer disconnected";
    ConsumerState["Connected"] = "Connected";
})(ConsumerState || (ConsumerState = {}));
export var MigrationState;
(function (MigrationState) {
    MigrationState["None"] = "No migration";
    MigrationState["InProgress"] = "Migration in progress";
    MigrationState["Completed"] = "Migration completed";
})(MigrationState || (MigrationState = {}));
export class ConsumerInfo {
    enabled;
    muted;
    state;
    migration;
    producerScores;
    consumerScores;
    overAllowed;
    overAllowedReason;
    videoEnabled;
    video;
    screenVideo;
    streamStatePaused;
    lastAudioMutedTimestamp;
    constructor(state = ConsumerState.WaitingForSFUAddress) {
        this.enabled = { audio: false, video: false, screen: false, sound: false };
        this.videoEnabled = false;
        this.muted = { audio: false, video: false, screen: false, sound: false };
        this.state = state;
        this.migration = MigrationState.None;
        this.producerScores = { audio: 10, video: 10, screen: 10, sound: 10 };
        this.consumerScores = { audio: 10, video: 10, screen: 10, sound: 10 };
        this.overAllowed = false;
        this.overAllowedReason = "";
        this.streamStatePaused = { video: false, screen: false };
        this.lastAudioMutedTimestamp = gatherVideoClientDataSource.performance().now();
    }
    summarize() {
        return {
            video: this.video?.summarize(),
            screenVideo: this.screenVideo?.summarize(),
            enabled: this.enabled,
            muted: this.muted,
            connectionState: this.state,
            migration: this.migration,
            streamStatePaused: this.streamStatePaused,
        };
    }
}
export function createConsumerInfo(state, id) {
    const info = new ConsumerInfo(state);
    info.video = new PlayerMediaSource({ playerId: id });
    info.screenVideo = new PlayerMediaSource({ playerId: id, isScreen: true });
    return info;
}
//# sourceMappingURL=ConsumerInfo.js.map